import { c as createStore } from "./index-c510313d.js";
export { N as NylasIdentityRequestWrapper } from "./nylas-api-request-abccdc65.js";
import "./index-091600eb.js";
import "./utils-43004f5a.js";
import "./utc-db61ec3a.js";
const store = createStore({});
export { store as NylasThemeStore };